export default {
    computed: {
        repetidor() {
            return this.$store.state.repetidor;
        },
        repetidor_id() {
            return this.$route.params.id;
        }
    }
};
